import GroupIcon from '@material-ui/icons/Group';

const UsersIcon = GroupIcon;

export default UsersIcon;